<template>
    <app-mail-popup ref="popup" label="Envoyer le compte-rendu">
        <div>
            <app-select
                :value="selectedMailTemplateId"
                @change="onSelectedMailTemplateChanged"
                :label="$t('project.diffusion.chooseMailTemplateLabel')"
            >
                <option :value="mailTemplate.id" v-for="mailTemplate in mailTemplates">{{ mailTemplate.name }}</option>
            </app-select>
        </div>
    </app-mail-popup>
</template>

<script>
import { getMailTemplates } from '@/features/mailTemplates/mailTemplates.service';
import AppSelect from '@/components/appSelect/AppSelect.vue';
import AppMailPopup from '@/features/planningExports/AppMailPopup.vue';
import { getLastMailTemplateId, saveLastMailTemplateId } from '@/services/mailPopupService';
import { getProject } from '@/features/projects/projects.service';

export default {
    components: {
        AppMailPopup,
        AppSelect,
    },
    async created() {
        this.subscriptions = [
            getMailTemplates(this.$route.params.projectId).subscribe((mailTemplates) => {
                this.mailTemplates = mailTemplates.filter((mailTemplate) => mailTemplate.type === 'observationsReport');
            }),
            getProject(this.$route.params.projectId).subscribe((project) => {
                this.project = project;
            }),
        ];
    },
    methods: {
        open(observationsReport, file, relevantBundleIds) {
            this.observationsReport = observationsReport;
            this.file = file;
            this.relevantBundleIds = relevantBundleIds;
            this.onSelectedMailTemplateChanged(getLastMailTemplateId(this.cacheKey, this.mailTemplates));
            this.$refs.popup.open();
        },
        replaceTokens(string) {
            if (!string) {
                return string;
            }
            const reportLink = `https://app.tex.moe/api/projects/${this.$route.params.projectId}/observationsReports/${this.observationsReport.id}/${this.file.bundleId}/report.pdf`;
            return string
                .replaceAll('NomRapport', this.observationsReport.name)
                .replaceAll('NomOperation', this.project.name)
                .replaceAll('LienRapport', `<a href="${reportLink}">${this.file.name}</a>`);
        },
        onSelectedMailTemplateChanged(mailTemplateId) {
            this.selectedMailTemplateId = mailTemplateId;
            saveLastMailTemplateId(this.cacheKey, mailTemplateId);
            this.applyMailTemplate(this.mailTemplates.find((mailTemplate) => mailTemplate.id === mailTemplateId));
        },
        applyMailTemplate(template) {
            this.$refs.popup.updateMail({
                subject: this.replaceTokens(template.subject),
                body: this.replaceTokens(template.body),
                recipientIds: [...template.to, ...this.relevantBundleIds],
                copyIds: template.cc,
                attachments: [
                    {
                        fileName: this.file.name,
                        url: this.file.url,
                    },
                ],
            });
        },
    },
    data() {
        return {
            project: null,
            cacheKey: 'observationsReport.lastMailTemplate.' + this.$route.params.projectId,
            observationsReport: null,
            subscriptions: [],
            mailTemplates: [],
            selectedMailTemplateId: null,
            file: null,
        };
    },
};
</script>
